import styled from "styled-components/macro";

export const MenuContainer = styled.div`
  min-width: 100px;

  &:focus {
    outline: none;
  }

  .custom-field-action-menu__inner {
    background-color: var(--menu-color);
    width: 100%;
    height: 100%;
    box-shadow: var(--default-drop-shadow);
    border-radius: 14px;
    padding: 4px;
    max-width: 400px;
    max-height: min(416px, var(--action-menu-max-height, 416px));
    overflow-y: auto;
  }

  .menu-item {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    padding: 10px 12px;
    border-radius: 10px !important;
    cursor: pointer;
    height: 24px;

    &:hover:not(.disabled) {
      background-color: var(--menu-color-hover);
    }
    &:active:not(.disabled) {
      background-color: var(--menu-color-active);
    }

    &.highlighted:not(.disabled) {
      background-color: var(--menu-color-hover);
      outline: 2px solid var(--primary-cta);
      outline-offset: -2px;
    }

    &.active:not(.disabled) {
      background: var(--selected-element-background);
    }

    &.disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }

    .label {
      font-size: 16px;
      white-space: nowrap;
      color: var(--grey-0);
      font-weight: 500;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      line-height: 1.3;
    }

    &.import {
      .icon {
        svg {
          path {
            fill: none;
          }
        }
      }
    }

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      margin-right: 10px;

      svg {
        path {
          fill: var(--grey-0);
          stroke: none;
        }
      }

      &.stroke {
        svg {
          path {
            fill: none;
            stroke: var(--grey-0);
          }
        }
      }
    }

    &.danger {
      .label {
        color: var(--danger-color);
      }
      .icon {
        path {
          fill: var(--danger-color);
          stroke: none;
        }

        &.stroke {
          svg {
            path {
              fill: none;
              stroke: var(--danger-color);
            }
          }
        }
      }
    }

    &.destructive {
      &:hover {
        background-color: var(--danger-color-hover);
      }

      &:active {
        background-color: var(--danger-color-active);
      }

      .label {
        color: var(--danger-color);
      }

      svg {
        path {
          fill: var(--danger-color);
        }
      }
    }
  }

  svg.import {
    path {
      fill: none;
      stroke: var(--grey-0) !important;
    }
    margin: 0 5px 0 4px;
  }
`;
